const directive = (el, binding) => {
  el.addEventListener('input', (event) => {
    const target = event.target;
    if (target?.value) {
      if (target.value.length > binding.value) {
        target.value = target.value.slice(0, binding.value);
        target.dispatchEvent(new Event('input'));
      }
    }
  });
}

export default directive;
